import { isEmpty } from 'radash';
import { IAllCollection, IAllCollectionData, IRecipeThumb } from '@modules/collections/domain/models/allCollection.model';
import { CollectionWithRecipeResponse, GetAllCollectionResponse, RecipeResponse } from '@modules/libs/graphql/generated/graphql';
export class AllCollectionEntityMapper {
  public static toDomain(allCollectionResponse: GetAllCollectionResponse): IAllCollection {
    const {
      total,
      collections
    } = allCollectionResponse;
    return {
      collections: this.allCollectionMapper(collections),
      total
    };
  }
  private static allCollectionMapper(collections: CollectionWithRecipeResponse[]): IAllCollectionData[] {
    return collections.map(({
      id,
      slugUrl,
      title,
      recipeList,
      recipeListTotal
    }) => {
      return {
        id,
        name: title,
        slug: slugUrl,
        menuAmount: recipeListTotal ?? 0,
        recipeList: this.recipeMapper(recipeList)
      };
    });
  }
  private static recipeMapper(recipeList: RecipeResponse[]): IRecipeThumb[] {
    return recipeList.map(({
      id,
      slugUrl,
      thumbUrl
    }) => {
      return {
        id,
        imageUrl: thumbUrl,
        slug: isEmpty(slugUrl) ? id.toString() : slugUrl
      };
    });
  }
}